import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { appConstants } from '../../../../shared/constants/app-constants';
import { IProjectDetails, IProjectStatusDto } from '../../shared/models/project-details';
import { ProjectPhases, MuleProjectPhases } from '../../../../shared/constants/project-phases-constants';
interface ITimelinePhase {
  phase: string;
  startDate?: string;
  endDate?: string;
  statusForCompletion?: string[];
  statusForCurrent?: string[];
  completed?: boolean;
  currentStep?: boolean;
  isShowingPhasePeriod: boolean;
  mulesoftPhase: string;
}

@Component({
    selector: 'app-project-details-timeline',
    templateUrl: './project-details-timeline.component.html',
    styleUrl: './project-details-timeline.component.scss',
    standalone: false
})
export class ProjectDetailsTimelineComponent implements OnChanges {

  @Input() projectDetails: IProjectDetails | null = null;

  phases: ITimelinePhase[] = [
    {
      phase: ProjectPhases.PROJECT_APPROVAL,
      completed: true,
      isShowingPhasePeriod: false,
      mulesoftPhase: MuleProjectPhases.PROJECT_APPROVAL
    },
    {
      phase: ProjectPhases.PROJECT_SETUP,
      completed: true,
      isShowingPhasePeriod: false,
      mulesoftPhase: MuleProjectPhases.PROJECT_SETUP
    },
    {
      phase: ProjectPhases.DRAFTING,
      statusForCompletion: [
        appConstants.publicationStatus.commenting,
        appConstants.publicationStatus.commentingAndBalloting,
        appConstants.publicationStatus.commentingCompleted,
        appConstants.publicationStatus.balloting,
        appConstants.publicationStatus.ballotingCompleted,
        appConstants.publicationStatus.published
      ],
      statusForCurrent: [
        appConstants.publicationStatus.drafting
      ],
      isShowingPhasePeriod: false,
      mulesoftPhase: MuleProjectPhases.DRAFTING
    },
    {
      phase: ProjectPhases.PUBLIC_COMMENT,
      statusForCompletion: [
        appConstants.publicationStatus.balloting,
        appConstants.publicationStatus.ballotingCompleted,
        appConstants.publicationStatus.published
      ],
      statusForCurrent: [
        appConstants.publicationStatus.commenting,
        appConstants.publicationStatus.commentingAndBalloting,
        appConstants.publicationStatus.commentingCompleted
      ],
      isShowingPhasePeriod: false,
      mulesoftPhase: MuleProjectPhases.PUBLIC_COMMENT
    },
    {
      phase: ProjectPhases.BALLOT,
      statusForCompletion: [
        appConstants.publicationStatus.published
      ],
      statusForCurrent: [
        appConstants.publicationStatus.balloting,
        appConstants.publicationStatus.commentingAndBalloting,
        appConstants.publicationStatus.ballotingCompleted
      ],
      isShowingPhasePeriod: false,
      mulesoftPhase: MuleProjectPhases.BALLOT
    },
    {
      phase: ProjectPhases.PUBLICATION,
      statusForCompletion: [
        appConstants.publicationStatus.published
      ],
      isShowingPhasePeriod: false,
      mulesoftPhase: MuleProjectPhases.PUBLICATION
    }
  ];

  ngOnChanges(changes: SimpleChanges): void {
    const projectDetails = changes['projectDetails'].currentValue;
    if (projectDetails) {
      const projectCommentStatus = projectDetails.projectCommentStatusDto;
      this.phases
        .forEach((phaseValues, index) => {
          phaseValues.completed = (!phaseValues.statusForCompletion || phaseValues.statusForCompletion.length === 0)
            || phaseValues.statusForCompletion.findIndex(x => x === projectDetails.phaseId) >= 0;

          if(phaseValues.phase == ProjectPhases.PROJECT_APPROVAL) {
            const approvalDate = projectDetails.projectApprovalDate;
            if(approvalDate){
              phaseValues.startDate = this.formatDate(approvalDate);
              phaseValues.endDate = this.formatDate(approvalDate);
              phaseValues.isShowingPhasePeriod = true;
            }
          }
          if(projectCommentStatus && projectCommentStatus.status && projectCommentStatus.status.length > 0) {
            const phase = projectCommentStatus.status?.find((x: IProjectStatusDto) => x.statusName === phaseValues.mulesoftPhase);
            if(phase) {
              phaseValues.startDate = this.formatDate(phase.startDate);
              phaseValues.endDate = this.formatDate(phase.startEnd);
              phaseValues.isShowingPhasePeriod = true;
            }
            let combinedProcedureStatus = projectCommentStatus.status.find((status: IProjectStatusDto) => status.statusName == MuleProjectPhases.COMBINED_PROCEDURE);
            if(combinedProcedureStatus &&
              (phaseValues.phase === ProjectPhases.PUBLIC_COMMENT || phaseValues.phase === ProjectPhases.BALLOT)
            ) {
              phaseValues.startDate = this.formatDate(combinedProcedureStatus.startDate);
              phaseValues.endDate = this.formatDate(combinedProcedureStatus.startEnd);
              phaseValues.isShowingPhasePeriod = true;
            }

          }

            phaseValues.currentStep = phaseValues.completed ?
                              false :
                              (!phaseValues.statusForCurrent || phaseValues.statusForCurrent.length === 0 ? false : phaseValues.statusForCurrent.findIndex(x => x === projectDetails.phaseId) >= 0);
        });
    }
  }

  formatDate(date: any): string {
  if (date) {
    const validDate = date instanceof Date ? date : new Date(date);
    return validDate.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).toUpperCase();
  }
  return '';
}

  getIdName(phase: string): string {
    return phase.replace(/\s+/g, '-').toLowerCase() + '-timeline';
  }

}
